var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isExecutive)?_c(_setup.ExecutiveAvatar,{attrs:{"executive":_vm.entity,"size":_vm.size}}):(_setup.isCompany)?_c(_setup.CompanyAvatar,{attrs:{"company":_vm.entity,"size":_vm.size}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }